import * as React from 'react';
import { EPageTypes, EPlatformTypes, handleDynamicCalltracking } from '@cian/frontend-newbuilding-call-component';

import { IBuilder, ISeller } from '../../types/newbuildingsCompare';
import { phoneToString } from '../../utils/phone/phoneToString';
import { useApplicationContext } from '../../utils/applicationContext';
import { TSellerType, trackShowPhone } from '../NewbuildingCallButton/tracking';
import { phoneToFormat } from './phoneToFormat';

const PLACE_TYPE = 'newbuildingCompare';

interface IUseDynamicPhoneCallParams {
  newbuildingId: number;
  url: string;
  target: IBuilder | ISeller;
  sellerType: TSellerType;
}

/**
 * Возвращает обработчик дозвона: резолвит номер динамического коллтрекинга (если есть
 * siteBlockId), иначе берёт статический телефон, трекает расхлоп и уходит в `tel:`.
 * Общий для одиночной кнопки и кнопок контактов в модалке.
 */
export function useDynamicPhoneCall({
  newbuildingId,
  url,
  target,
  sellerType,
}: IUseDynamicPhoneCallParams): () => Promise<void> {
  const { httpApi, logger } = useApplicationContext();

  return React.useCallback(async () => {
    const siteBlockId = target.newbuildingDynamicCalltracking?.siteBlockId;
    let dynamicPhone: string | null = null;

    if (siteBlockId) {
      const response = await handleDynamicCalltracking({
        httpApi,
        logger,
        blockId: siteBlockId,
        platformType: EPlatformTypes.WebMobile,
        pageType: EPageTypes.OfferComparison,
        placeType: PLACE_TYPE,
        announcementId: newbuildingId,
      });

      dynamicPhone = phoneToFormat(response?.notFormattedPhone ?? null);
    }

    // Нормализуем статический номер для tel:: убираем возможный ведущий «+» и российский
    // междугородний префикс 8 → 7 (иначе для countryCode «8» получится невалидный +8…).
    const staticPhoneDigits = phoneToString({ phone: target.phone }).replace(/^\+/, '');
    const staticPhone = staticPhoneDigits ? `+${staticPhoneDigits.replace(/^8/, '7')}` : '';

    trackShowPhone({ newbuildingId, url, sellerType });

    window.location.href = `tel:${dynamicPhone || staticPhone}`;
  }, [httpApi, logger, target, newbuildingId, url, sellerType]);
}
